module.exports = __webpack_public_path__ + "static/assets/2fdc9a7555af004ace3a5cb0d28346ce.svg";